import type { VideoSortOption } from '@modules/professional/type/company-videos';
import type { VideosSortFields } from 'generated/graphql';
import { SortDirection } from 'generated/graphql';
import type { ConstantLengthArray } from '~/utils/types';

const getVimeoVideoUrl = (videoID: string) => {
    return `https://vimeo.com/${videoID}`;
};

const getYoutubeVideoUrl = (videoID: string) => {
    return `https://youtu.be/${videoID}`;
};

export const getVideoUrl = (videoType: string, videoID: string) => {
    if (videoType === 'Vimeo') {
        return getVimeoVideoUrl(videoID);
    }

    return getYoutubeVideoUrl(videoID);
};

export const SORT_DEFAULT_INDEX = 0;
export const SORT_PLACEHOLDER_LABEL = 'Sort';

export const SORT_OPTIONS: ConstantLengthArray<
    {
        item: string;
        param: VideoSortOption;
    },
    4
> = [
    { item: 'Featured', param: null },
    { item: 'Newest to oldest', param: 'createdDesc' },
    { item: 'Oldest to newest', param: 'createdAsc' },
    { item: 'A-Z', param: 'alphabetical' },
];

export const mapSortOptionToVariable: (
    sort: VideoSortOption | null | undefined,
) => VideosSortFields = (sort) => {
    switch (sort) {
        case 'createdAsc':
            return { Created: SortDirection.Asc };
        case 'alphabetical':
            return { Title: SortDirection.Asc };
        case 'type':
            return { Type: SortDirection.Asc };
        case 'createdDesc':
            return { Created: SortDirection.Desc };
        case 'featured':
        default:
            return { MemberSortOrder: SortDirection.Desc };
    }
};
